import { Base } from './base.model';

export class ReportConfig extends Base {
  reportType: string;
  methodology: string;
  version: number;
  config: any;
}
